<template>
    <div>
        <div style="max-width: 600px">
            <Formoj
                class="cursus-formoj m-0"
                :form-id="formId"
                :answer-id="answerId"
                :show-submit="false"
                :large-buttons="false"
                :loading="loading"
                appearance="default"
                stack-sections
                ref="formoj"
            />
        </div>
    </div>
</template>

<script>
    import { Formoj, FormojAnswer } from 'formoj';


    export default {
        components: {
            Formoj,
            FormojAnswer,
        },
        props: {
            order: Object,
            course: Object,
            loading: Boolean,
            confirmationForm: Boolean,
        },
        computed: {
            formId() {
                if(this.confirmationForm) {
                    return this.course.confirmation_form_id;
                }
                return this.course.registration_form_id;
            },
            answerId() {
                if(this.confirmationForm) {
                    return this.order.registrants[0]?.confirmation_answer_id;
                }
                return this.order.registrants[0]?.registration_answer_id;
            },
        },
        methods: {
            async submit(params) {
                return this.$refs.formoj?.submit(params) ?? {
                    answer_id: this.answerId,
                };
            },
        }
    }
</script>
